import type { ReactNode } from 'react'
import PortfolioKpiValueMotion from './PortfolioKpiValueMotion'
import ClimateMetricCard from '../common/ClimateMetricCard'

type PortfolioSummaryMetricCardProps = {
  title: string
  transitionKey: string
  children: ReactNode
  valueAlign?: 'flex-start' | 'center' | 'flex-end'
  minValueHeight?: number
}

const PortfolioSummaryMetricCard = ({
  title,
  transitionKey,
  children,
  valueAlign = 'flex-start',
  minValueHeight = 24,
}: PortfolioSummaryMetricCardProps) => {
  return (
    <ClimateMetricCard title={title} variant="elevation" contentSx={{ height: '100%' }}>
      <PortfolioKpiValueMotion transitionKey={transitionKey} minHeight={minValueHeight} justifyContent={valueAlign}>
        {children}
      </PortfolioKpiValueMotion>
    </ClimateMetricCard>
  )
}

export default PortfolioSummaryMetricCard
